export const MOBILE_BANNER_TITLE = 'Скачать_приложение_футер';
